import { type ReportViewChart } from '@/types/schema/views/ReportView';
import { cn } from '@/utils/tailwind';
import { useChartContext } from '@/components/views/report/ChartContext';
import { ChartFiltersChips } from '@/components/views/report/filters/ChartFilterChips';
import { ChartFiltersPopover } from '@/components/views/report/filters/ChartFiltersPopover';
import { ChartMenuFilters } from '@/components/views/report/filters/ChartMenuFilters';
import { useChartFilters } from '@/components/views/report/filters/useChartFilters';

const getChartProperties = (chart: ReportViewChart) => ({
  filterType: chart.filters.filter_type,
  menuFilters: chart.filters.menu_filters || []
});

export function ChartToolbarSection({
  chart,
  className
}: {
  chart: ReportViewChart;
  className?: string;
}) {
  const { sourceTable } = useChartContext();
  const { visibleFilters } = useChartFilters(chart);

  const { filterType, menuFilters } = getChartProperties(chart);

  const hasMenuFilters = menuFilters && menuFilters?.length > 0 && filterType === 'menu';
  const shouldNotRenderToolbarSection = filterType !== 'fields' && !hasMenuFilters;

  if (shouldNotRenderToolbarSection || !sourceTable) {
    return null;
  }

  return (
    <div className={cn(className, 'flex flex-col gap-2')}>
      {filterType === 'fields' && (
        <div className={cn('flex flex-row flex-wrap items-center gap-2 md:justify-between')}>
          {filterType === 'fields' && (
            <div className="flex flex-row flex-wrap items-center gap-2">
              {filterType === 'fields' && (
                <ChartFiltersPopover chart={chart} sourceObject={sourceTable} />
              )}

              {visibleFilters && visibleFilters.rules.length > 0 && !hasMenuFilters && (
                <ChartFiltersChips visibleFilters={visibleFilters} />
              )}
            </div>
          )}
        </div>
      )}

      {hasMenuFilters && (
        <div className="mt-2 w-fit" data-testid="view-menu-filters">
          <ChartMenuFilters menuFilters={menuFilters} />
        </div>
      )}
    </div>
  );
}
